import React from 'react';

function Filters({handleFilterShipping}) {

  return (
    <div className="flex flex-col justify-start ">

    <div>
    <h1 className='font-extrabold text-lg'>Delivery Option & Services</h1>
      </div>  



<div className='flex flex-row justify-start items-center mt-4'>
<input type='checkbox'  className='mr-2 size-6' onChange={(e)=>handleFilterShipping(e)}/>
<p className='text-lg'>Free Shipping</p>
</div>
    
<div>
<div className='mt-4'>
    <h1 className='font-extrabold text-lg'>Price Filter</h1>
      </div> 

      

</div>




    </div>



  );
}

export default Filters;
